import {CHAT_API_URL, ROCKET_CHAT_SERVICE_DOMAIN} from "../../../constants/api";

export const USER_SECRET_URL = `${CHAT_API_URL}/v1/message/secret`;
export const ROCKET_CHAT_DOMAIN = ROCKET_CHAT_SERVICE_DOMAIN;
export const ROCKET_CHAT_LOGIN_URL = `https://${ROCKET_CHAT_SERVICE_DOMAIN}/api/v1/login`
export const ROCKET_CHAT_HISTORY_URL = `https://${ROCKET_CHAT_SERVICE_DOMAIN}/api/v1/im.history`